import React from 'react'
import { Icon } from '../'

const ObjectActive = ({ object }) => {
  return (
    <Icon
      iconName="check-circle"
      color={object.active ? 'text-green-400' : 'text-red-400'}
      className="mx-3"
    />
  )
}

export default ObjectActive
